module.exports = __webpack_public_path__ + "70ac21634afc676945af5d01cf1104aa.svg";